import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChat = () => {
  return (
    <g>
      <path d="M9.75 0a1.75 1.75 0 0 1 1.744 1.606l.006.144v2.249L14.25 4c.966 0 1.75.784 1.75 1.75v6l-.006.144A1.75 1.75 0 0 1 14.25 13.5H14v1.75l-.007.103a.75.75 0 0 1-1.223.473L9.979 13.5H7.25a1.75 1.75 0 0 1-1.75-1.75V9.934l-2.27 1.892a.751.751 0 0 1-1.204-.375l-.02-.098L2 11.25V9.5h-.25A1.75 1.75 0 0 1 .024 8.042l-.018-.148L0 7.75v-6A1.75 1.75 0 0 1 1.606.006L1.75 0h8zM7 11.75c0 .138.112.25.25.25h3l.104.007a.75.75 0 0 1 .376.167l1.77 1.473v-.897a.75.75 0 0 1 .75-.75h1a.25.25 0 0 0 .25-.25v-6a.25.25 0 0 0-.25-.25h-7a.25.25 0 0 0-.25.25v6zM9.75 1.5h-8a.25.25 0 0 0-.243.193L1.5 1.75v6a.25.25 0 0 0 .193.243L1.75 8h1a.75.75 0 0 1 .743.648l.007.102v.897l1.77-1.473a.75.75 0 0 1 .23-.131V5.75C5.5 4.784 6.284 4 7.25 4L10 3.999V1.75a.25.25 0 0 0-.193-.243L9.75 1.5z" />
    </g>
  );
};

export default withIcon(IconChat);
